import { NavLink, useLocation } from "react-router-dom";
import { Home, BookOpen, Phone, User, MoreHorizontal } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/courses", label: "Courses", icon: BookOpen },
  { to: "/contact", label: "Enquire", icon: Phone, primary: true },
  { to: "/student/login", label: "Portal", icon: User },
  { to: "/faq", label: "More", icon: MoreHorizontal },
];

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  // Hide on admin/student full-screen routes
  if (pathname.startsWith("/admin") || pathname.startsWith("/student/")) return null;

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-xl border-t border-slate-200 pb-[env(safe-area-inset-bottom)]"
    >
      <div className="grid grid-cols-5 h-16">
        {NAV.map(({ to, label, icon: Icon, end, primary }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={`bottom-nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `relative flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium transition-colors ${
                isActive ? "text-[#FF6B35]" : "text-slate-500 hover:text-[#0B192C]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                {primary ? (
                  <span className="absolute -top-5 w-12 h-12 rounded-full grid place-items-center shadow-lg shadow-[#FF6B35]/40 bg-[#FF6B35] text-white ring-4 ring-white">
                    <Icon size={18} />
                  </span>
                ) : (
                  <Icon size={20} className={isActive ? "text-[#FF6B35]" : ""} />
                )}
                <span className={primary ? "mt-6" : ""}>{label}</span>
                {isActive && !primary && (
                  <span className="absolute top-1 w-6 h-0.5 rounded-full bg-[#FF6B35]" />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
